(function () {
  var reduce = window.matchMedia("(prefers-reduced-motion: reduce)").matches;
  var locks = 0;

  function lock() {
    locks += 1;
    if (locks > 1) return;
    var root = document.documentElement;
    var gap = Math.max(0, window.innerWidth - root.clientWidth);
    root.style.setProperty("--cjet-scroll-gap", gap + "px");
    root.classList.add("cjet-scroll-lock");
  }

  function unlock() {
    locks = Math.max(0, locks - 1);
    if (locks !== 0) return;
    var root = document.documentElement;
    root.classList.remove("cjet-scroll-lock");
    root.style.removeProperty("--cjet-scroll-gap");
  }

  function focusables(root) {
    return Array.prototype.slice.call(
      root.querySelectorAll('a[href],button:not([disabled]),input:not([disabled]),select:not([disabled]),textarea:not([disabled]),[tabindex]:not([tabindex="-1"])')
    );
  }

  function trap(e, root) {
    if (e.key !== "Tab") return;
    var nodes = focusables(root);
    if (!nodes.length) return;
    var first = nodes[0];
    var last = nodes[nodes.length - 1];
    if (e.shiftKey && document.activeElement === first) {
      e.preventDefault();
      last.focus();
    } else if (!e.shiftKey && document.activeElement === last) {
      e.preventDefault();
      first.focus();
    }
  }

  function openDrawer(el) {
    if (!el || el.classList.contains("is-open")) return;
    if (!el._cjetHome) el._cjetHome = el.parentNode;
    if (el.parentNode !== document.body) document.body.appendChild(el);
    el.hidden = false;
    el.classList.add("is-open");
    el.setAttribute("data-open", "true");
    lock();
    var panel = el.querySelector(".cjet-drawer__panel") || el;
    var nodes = focusables(panel);
    if (nodes[0]) nodes[0].focus();
  }

  function closeDrawer(el) {
    if (!el || !el.classList.contains("is-open")) return;
    el.classList.remove("is-open");
    el.removeAttribute("data-open");
    unlock();
    window.setTimeout(function () {
      if (el.classList.contains("is-open")) return;
      el.hidden = true;
      if (el._cjetHome && el.parentNode !== el._cjetHome) el._cjetHome.appendChild(el);
    }, reduce ? 0 : 280);
  }

  function bindDrawer(el) {
    if (el.getAttribute("data-cjet-bound") === "1") return;
    el.setAttribute("data-cjet-bound", "1");
    var panel = el.querySelector(".cjet-drawer__panel");
    var handle = el.querySelector("[data-cjet-drawer-handle]");
    el.addEventListener("click", function (e) {
      if (e.target.closest("[data-cjet-drawer-dismiss]")) closeDrawer(el);
    });
    el.addEventListener("keydown", function (e) {
      if (e.key === "Escape") closeDrawer(el);
      if (panel) trap(e, panel);
    });
    if (handle && panel && !reduce) {
      var startY = 0;
      var dy = 0;
      var dragging = false;
      handle.addEventListener("touchstart", function (e) {
        dragging = true;
        startY = e.touches[0].clientY;
        dy = 0;
      }, { passive: true });
      handle.addEventListener("touchmove", function (e) {
        if (!dragging) return;
        dy = e.touches[0].clientY - startY;
        if (dy > 0) panel.style.transform = "translateY(" + dy + "px)";
      }, { passive: true });
      handle.addEventListener("touchend", function () {
        if (!dragging) return;
        dragging = false;
        panel.style.transform = "";
        if (dy > 80) closeDrawer(el);
      });
    }
  }

  function bindNav() {
    var nav = document.getElementById("cjet-nav");
    if (!nav) return;
    var buttons = document.querySelectorAll("[data-menu-button]");
    function isMobile() {
      return window.matchMedia("(max-width: 749px)").matches;
    }
    function placeNav() {
      var shell = document.querySelector(".cjet-header-section");
      var edge = shell ? shell.getBoundingClientRect().bottom : 0;
      document.documentElement.style.setProperty("--cjet-nav-top", Math.max(0, Math.round(edge)) + "px");
    }
    function markButtons(on) {
      buttons.forEach(function (b) {
        b.setAttribute("aria-expanded", on ? "true" : "false");
        var label = b.getAttribute(on ? "data-aria-label-opened" : "data-aria-label-closed");
        if (label) b.setAttribute("aria-label", label);
      });
    }
    function openNav() {
      if (!isMobile()) return;
      if (!nav._cjetHome) nav._cjetHome = nav.parentNode;
      document.body.appendChild(nav);
      lock();
      placeNav();
      nav.classList.add("is-open");
      document.documentElement.classList.add("cjet-nav-lock");
      markButtons(true);
    }
    function closeNav() {
      nav.classList.remove("is-open");
      document.documentElement.classList.remove("cjet-nav-lock");
      unlock();
      var more = document.getElementById("cjet-nav-more");
      if (more) more.checked = false;
      if (nav._cjetHome) nav._cjetHome.appendChild(nav);
      markButtons(false);
    }
    buttons.forEach(function (b) {
      b.addEventListener("click", function (e) {
        if (!isMobile()) return;
        e.preventDefault();
        e.stopImmediatePropagation();
        if (nav.classList.contains("is-open")) closeNav();
        else openNav();
      }, true);
    });
    document.addEventListener("keydown", function (e) {
      if (e.key === "Escape" && nav.classList.contains("is-open")) closeNav();
    });
  }

  function cartCount(n) {
    document.querySelectorAll("[data-cart-count]").forEach(function (el) {
      el.setAttribute("data-cart-count", n);
      var badge = el.querySelector(".cjet-bar__count");
      if (badge) badge.textContent = n;
    });
    document.documentElement.dispatchEvent(new CustomEvent("cart:updated", { bubbles: true, detail: { item_count: n } }));
  }

  function bindQuickAdd() {
    document.addEventListener("touchstart", function (e) {
      var card = e.target.closest(".product-item");
      if (!card || !card.querySelector(".product-item__quick-add")) return;
      if (window.matchMedia("(hover: hover) and (pointer: fine)").matches) return;
      var timer = window.setTimeout(function () {
        card.classList.add("is-quick-add");
      }, 420);
      var clear = function () { window.clearTimeout(timer); };
      card.addEventListener("touchend", clear, { once: true });
      card.addEventListener("touchmove", clear, { once: true });
      card.addEventListener("touchcancel", clear, { once: true });
    }, { passive: true });
    document.addEventListener("click", function (e) {
      var wrap = e.target.closest("[data-cjet-atc]");
      if (wrap) {
        e.preventDefault();
        e.stopPropagation();
        var qtyEl = wrap.querySelector("[data-cjet-atc-qty]");
        var qty = qtyEl ? parseInt(qtyEl.textContent, 10) || 1 : 1;
        if (e.target.closest("[data-cjet-atc-dec]")) {
          qty = Math.max(1, qty - 1);
          if (qtyEl) qtyEl.textContent = String(qty);
          return;
        }
        if (e.target.closest("[data-cjet-atc-inc]")) {
          qty = Math.min(99, qty + 1);
          if (qtyEl) qtyEl.textContent = String(qty);
          return;
        }
        var go = e.target.closest("[data-cjet-atc-go]");
        if (!go) return;
        var id = wrap.getAttribute("data-variant-id");
        if (!id || go.disabled) return;
        go.disabled = true;
        fetch(((window.theme && window.theme.routes && window.theme.routes.cart && window.theme.routes.cart.add) || "/cart/add.js"), {
          method: "POST",
          headers: { "Content-Type": "application/json", Accept: "application/json" },
          body: JSON.stringify({ id: Number(id), quantity: qty })
        }).then(function (r) {
          if (!r.ok) throw new Error("add");
          return fetch("/cart.js");
        }).then(function (r) { return r.json(); }).then(function (cart) {
          go.disabled = false;
          cartCount(cart.item_count);
        }).catch(function () {
          go.disabled = false;
        });
        return;
      }
      document.querySelectorAll(".product-item.is-quick-add").forEach(function (card) {
        card.classList.remove("is-quick-add");
      });
    });
  }

  function bindRail(rail) {
    if (!rail || rail.getAttribute("data-cjet-rail-on") === "1") return;
    var slider = rail.querySelector(".scroll-slider__slider") || rail.querySelector("[data-cjet-rail-track]");
    if (!slider) return;
    rail.setAttribute("data-cjet-rail-on", "1");
    slider.setAttribute("tabindex", "0");
    function step() { return slider.clientWidth * 0.8; }
    function go(dir) {
      slider.scrollBy({ left: dir * step(), behavior: reduce ? "auto" : "smooth" });
    }
    slider.addEventListener("keydown", function (e) {
      if (e.key === "ArrowRight") {
        e.preventDefault();
        go(1);
      }
      if (e.key === "ArrowLeft") {
        e.preventDefault();
        go(-1);
      }
    });
    var prev = rail.querySelector("[data-scroll-slider-prev-button]");
    var next = rail.querySelector("[data-scroll-slider-next-button]");
    if (prev) {
      prev.classList.remove("hidden");
      prev.addEventListener("click", function (e) {
        e.preventDefault();
        go(-1);
      });
    }
    if (next) {
      next.classList.remove("hidden");
      next.addEventListener("click", function (e) {
        e.preventDefault();
        go(1);
      });
    }
  }

  function bindRails() {
    document.querySelectorAll("[data-cjet-rail]").forEach(bindRail);
  }

  function bindHoverImage() {
    var fine = window.matchMedia("(hover: hover) and (pointer: fine)");
    document.addEventListener("pointerenter", function (e) {
      if (!fine.matches) return;
      var card = e.target.closest ? e.target.closest(".product-item[data-i2]") : null;
      if (!card || card.querySelector(".product-item__image--two")) return;
      var media = card.querySelector(".product-item__media");
      if (!media) return;
      var img = document.createElement("img");
      img.className = "product-item__image product-item__image--two";
      img.src = card.getAttribute("data-i2");
      img.alt = "";
      img.decoding = "async";
      media.appendChild(img);
    }, true);
  }

  function bindLazyRails() {
    var nodes = document.querySelectorAll("[data-cjet-lazy-rail]");
    if (!nodes.length) return;
    function fill(el) {
      var src = el.getAttribute("data-src");
      if (!src || el.getAttribute("data-cjet-lazy-on") === "1") return;
      el.setAttribute("data-cjet-lazy-on", "1");
      fetch(src, { credentials: "same-origin" }).then(function (r) { return r.text(); }).then(function (html) {
        var doc = new DOMParser().parseFromString(html, "text/html");
        var rail = doc.querySelector("[data-cjet-rail]");
        if (!rail) return;
        el.replaceWith(rail);
        bindRail(rail);
      }).catch(function () {
        el.removeAttribute("data-cjet-lazy-on");
      });
    }
    if (!("IntersectionObserver" in window)) {
      nodes.forEach(fill);
      return;
    }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (!entry.isIntersecting) return;
        io.unobserve(entry.target);
        fill(entry.target);
      });
    }, { rootMargin: "480px 0px" });
    nodes.forEach(function (n) { io.observe(n); });
  }

  function blockXr() {
    if (!window.Shopify || !window.Shopify.loadFeatures) return;
    var orig = window.Shopify.loadFeatures.bind(window.Shopify);
    window.Shopify.loadFeatures = function (features, cb) {
      var next = (features || []).filter(function (f) {
        return f && f.name !== "shopify-xr" && f.name !== "model-viewer-ui";
      });
      if (!next.length) {
        if (typeof cb === "function") cb();
        return;
      }
      return orig(next, cb);
    };
  }

  function boot() {
    blockXr();
    document.querySelectorAll("[data-cjet-drawer]").forEach(bindDrawer);
    bindNav();
    bindQuickAdd();
    bindHoverImage();
    bindRails();
    bindLazyRails();
    document.addEventListener("click", function (e) {
      var openBtn = e.target.closest("[data-cjet-drawer-open]");
      if (!openBtn) return;
      var id = openBtn.getAttribute("data-cjet-drawer-open");
      var el = document.querySelector('[data-cjet-drawer-id="' + id + '"]');
      if (!el) return;
      if (el.classList.contains("is-open")) closeDrawer(el);
      else openDrawer(el);
    });
    window.cjetDrawer = { open: openDrawer, close: closeDrawer };
  }

  if (document.readyState === "loading") document.addEventListener("DOMContentLoaded", boot);
  else boot();
})();
